import useSWR from 'swr';
import { BlogItem, BlogResponse, SearchPayload } from '../../types/blogs/index';
import { axiosInstanceAdminhub } from '../serviceAdminhub';

const endpoints = {
  list: '/blogs/search',
  detail: (id: string) => `/blogs/get/${id}`,
};

/* ************** */
/* Blog List */
const getBlogList = (params: SearchPayload) =>
  axiosInstanceAdminhub.post<BlogResponse>(endpoints.list, {
    ...params,
  });

const useBlogList = (params: SearchPayload) => useSWR([endpoints.list, params], () => getBlogList(params));

/* ************** */
/* Blog Detail */
const getBlogDetail = ({ id }: { id: string }) => axiosInstanceAdminhub.get<BlogItem>(endpoints.detail(id));

const useBlogDetail = ({ id }: { id: string }) => useSWR(endpoints.detail(id), () => getBlogDetail({ id }));

const api = {
  useBlogList,
  getBlogDetail,
  useBlogDetail,
};

export default api;
